export class SearchModelType {
    id: any;
    columnName: any;
    desc: any;

    constructor(newId: any, newDesc: any, newColumnName: any) {
        this.id = newId;
        this.desc = newDesc;
        this.columnName = newColumnName;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/search-model-type.ts